import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import ModalBase, { ModalBasicProps } from '@/components/layouts/Modal/Base';
import { defaultTheme } from '@/utility/theme';

import { Buttons, InfoWarningIcon, Text, Wrapper } from './style';

interface DeleteAllBetDataModalProps extends ModalBasicProps {
  deleteFunc: () => void;
}

const DeleteAllBetDataModal: React.FC<DeleteAllBetDataModalProps> = ({
  isOpen,
  deleteFunc,
  handleClose,
}) => {
  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={handleClose}
      backgroundColor={defaultTheme.background.white}
    >
      <Wrapper>
        <InfoWarningIcon />
        <Text>組み合わせを削除すると戻すことができません</Text>
        <Buttons>
          <Button
            size="m"
            bgColor="primary"
            fontWeight="bold"
            height="56px"
            radius="l"
            onClick={deleteFunc}
          >
            削除する
          </Button>
          <Button
            size="m"
            bgColor="darkGray"
            fontWeight="bold"
            height="56px"
            radius="l"
            type="reset"
            outline
            onClick={handleClose}
          >
            キャンセル
          </Button>
        </Buttons>
      </Wrapper>
    </ModalBase>
  );
};

export default DeleteAllBetDataModal;
